// extracted by mini-css-extract-plugin
module.exports = {"collection-headline":"collection-type-card_collection-headline__2dszB"};